export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11167.189b7c35.jpg";